<div class="wrap">
    <div class="content">
        <div id="content_boat" (click)="showMesssag()" >
            <img src="assets/img/sailing-24px.svg" id="boat">
            <div class="message_boat"  id="message_boat">
                <p class="message"  *ngIf="message">Bienvenue à bord !</p>
            </div>
            <div class="arrow-down" *ngIf="message"></div>
        </div>

        <div [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''" id="home_router_outlet">
            <router-outlet #o="outlet"></router-outlet>
        </div>
    </div>
</div>